import { graphql } from '~/gql'

export default graphql(`
  query ProductVariation($ids: [ID!]!) {
    ProductVariations(ids: $ids) {
      ...ProductVariationFragment
    }
  }
`)
